import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// ==================== INDIKASI ====================
async function getIndikasi() {
  const response = await http
    .getData("/mutu/sc-emergency/indikasi")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== EVENTS (CRUD) ====================
async function getList(params?: any) {
  const response = await http
    .getDataParam("/mutu/sc-emergency/events", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/mutu/sc-emergency/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/mutu/sc-emergency/events", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/mutu/sc-emergency/events/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/mutu/sc-emergency/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function submit(id: number, data: any) {
  const response = await http
    .postData(`/mutu/sc-emergency/events/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== 3-TIER SIGN ====================
async function signKaIbs(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/sc-emergency/events/${id}/sign-ka-ibs`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKomiteMutu(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/sc-emergency/events/${id}/sign-komite-mutu`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== LOOKUP ====================
async function lookupPatient(registerId: number) {
  const response = await http
    .getData(`/mutu/sc-emergency/lookup-patient/${registerId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getIbsCandidates(params?: any) {
  const response = await http
    .getDataParam("/mutu/sc-emergency/ibs-candidates", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== DASHBOARD & REKAP ====================
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam("/mutu/sc-emergency/dashboard", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getRekapHarian(params?: any) {
  const response = await http
    .getDataParam("/mutu/sc-emergency/rekap-harian", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== MONTHLY REPORT ====================
async function getMonthly(tahun: number, bulan: number) {
  const response = await http
    .getData(`/mutu/sc-emergency/monthly/${tahun}/${bulan}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function finalizeMonthly(tahun: number, bulan: number, data: any) {
  const response = await http
    .postData(`/mutu/sc-emergency/monthly/${tahun}/${bulan}/finalize`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function triggerAggregate(tahun: number, bulan: number) {
  const response = await http
    .postData(`/mutu/sc-emergency/monthly/${tahun}/${bulan}/trigger-aggregate`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== PDF ====================
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/mutu/sc-emergency/events/${id}/pdf`,
    "_blank"
  );
}

export default {
  getIndikasi,
  getList,
  find,
  create,
  update,
  destroy,
  submit,
  signKaIbs,
  signKomiteMutu,
  lookupPatient,
  getIbsCandidates,
  getDashboard,
  getRekapHarian,
  getMonthly,
  finalizeMonthly,
  triggerAggregate,
  printPdf,
};
